import * as React from 'react';

import {
  handlePrivacyManagerAction,
  listenForCookieConsentEvents,
  onUsePrivacyManagerHandler,
} from 'lib/cookie-consent';

type PageContainerProps = React.PropsWithChildren;

function PageContainer({ children }: PageContainerProps) {
  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return listenForCookieConsentEvents();
    } else {
      return;
    }
  }, []);
  React.useEffect(onUsePrivacyManagerHandler, []);

  // Bridge for _sp_.config.events.onPrivacyManagerAction in pages/_document.tsx -
  // that inline script can't import from here, so it calls this well-known global
  // instead. Handles CCPA specifically (see lib/cookie-consent.ts); GDPR privacy
  // manager actions are already covered by the __tcfapi listener above.
  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.__handlePrivacyManagerAction = handlePrivacyManagerAction;

      return () => {
        delete window.__handlePrivacyManagerAction;
      };
    } else {
      return;
    }
  }, []);

  return children;
}

export { PageContainer };
